import { Component, Input } from '@angular/core';
import { LoanApplication } from 'src/app/models/loan/loan-info.model';

@Component({
    selector: 'tpo-closing-info',
    templateUrl: 'tpo-closing-info.component.html',
    standalone: false
})

export class TpoClosingInfoComponent {

    private _application: LoanApplication;

    @Input()
    set application(application: LoanApplication) {
        this._application = application;
    }

    get application(): LoanApplication {
        return this._application;
    }

    @Input()
    set hiddenFields(hiddenFields: string[]) {
        this.isPayoffExpirationDateHidden = !!hiddenFields?.includes('payoffExpirationDate');
    }

    protected isPayoffExpirationDateHidden: boolean = false;
    constructor() { }
}